export const Lookup = {
  IsProduction: import.meta.env.VITE_IS_PRODUCTION === 'true',
  ClientIds: {
    FGI: 154,
    MediaLab: 4,
    Sitmatic: 100
  }
};
